'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002491 from "./presto.types$$anon$91.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload$0024 from "./presto.types$-Allow-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$90(outer) {
  this.ca3 = null;
  this.c9V = null;
  this.c9W = false;
  this.ca4 = null;
  this.ca5 = false;
  this.ca8 = null;
  this.ca1 = null;
  this.ca2 = false;
  this.c9X = null;
  this.c9Y = false;
  this.c9Z = null;
  this.ca0 = false;
  this.ca6 = false;
  this.ca7 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.ca3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ca8 = "AllowPayload";
}
export { $c_Lpresto_types$Rule$$anon$90 as $c_Lpresto_types$Rule$$anon$90 };
$p = $c_Lpresto_types$Rule$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$90;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$90() {
}
export { $h_Lpresto_types$Rule$$anon$90 as $h_Lpresto_types$Rule$$anon$90 };
$h_Lpresto_types$Rule$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.ca3;
});
$p.L = (function() {
  if ((!this.c9W)) {
    this.c9V = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9W = true;
  }
  return this.c9V;
});
$p.O = (function() {
  if ((!this.ca5)) {
    this.ca4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ca5 = true;
  }
  return this.ca4;
});
$p.E = (function() {
  return this.ca8;
});
$p.t = (function() {
  if ((!this.ca2)) {
    this.ca1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ca2 = true;
  }
  return this.ca1;
});
$p.M = (function() {
  if ((!this.c9Y)) {
    this.c9X = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SS(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.c9Y = true;
  }
  return this.c9X;
});
$p.Q = (function() {
  if ((!this.ca0)) {
    this.c9Z = new $j_presto$002etypes$0024$0024anon$002491.$c_Lpresto_types$$anon$91();
    this.ca0 = true;
  }
  return this.c9Z;
});
$p.w = (function() {
  if ((!this.ca7)) {
    this.ca6 = false;
    this.ca7 = true;
  }
  return this.ca6;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee90) => ((p) => \u03b4scrutinee90.cGn(p)))($j_presto$002etypes$0024$002dAllow$002dPayload$0024.$m_Lpresto_types$AllowPayload$())));
});
var $d_Lpresto_types$Rule$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$90, "presto.types$Rule$$anon$90", ({
  a1c: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$90 as $d_Lpresto_types$Rule$$anon$90 };
//# sourceMappingURL=presto.types$-Rule$$anon$90.js.map
